var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-app-bar',{attrs:{"flat":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("DATOS DE ENVÍO — Ticket "+_vm._s(_vm.datos.id))]),_c('v-spacer'),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.closeModal}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_c('v-card-text',{staticClass:"pa-0"},[_c('DatosEnvio')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }